import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fileUpload } from "../../redux/services/fileUploadSlice";
import { addClasses, editClasses, getAllExamType, getAllUsers, getSingleClasses } from "../../redux/services/classesSlice";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { VscEyeClosed } from "react-icons/vsc";
import { RxEyeOpen } from "react-icons/rx";
import { AiFillFilePdf } from "react-icons/ai";
import Select from "react-select";
import { getAllSubject } from "../../redux/services/subjectSlice";
// import { getAllStudent } from "../../redux/services/studentSlice";

const ClassesDataForm = ({ action }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getSubjectData = useSelector((state) => state?.subject?.subjectData);
  const getStudentData = useSelector((state) => state.classes.userData);
  const getExamTypeData = useSelector((state) => state.classes.examTypeData);
  const getsingleClassesData = useSelector((state) => state?.classes?.singleClassesData);

  const queryParams = new URLSearchParams(location.search);
  const classesId = queryParams.get("classesId");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [preview, setPreview] = useState(null);
  const [termsPreview, setTermsPreview] = useState(null);
  const [privacyPreview, setPrivacyPreview] = useState(null);
  const initialValues = {
    name: "",
    ownerName: "",
    contact: {
      countryCode: "+91",
      mobile: "",
    },
    email: "",
    subjectIds: [],
    userIds: [],
    isForAllUsers: true,
    referralCode: "",
    image: null,
    password: "",
    positiveMarks: "",
    negativeMarks: "",
    examTypeId: ""
  };

  const validationSchema = Yup.object({
    ownerName: Yup.string().required("Owner Name is required"),
    name: Yup.string().required("Class Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    password: Yup.string().min(8, "Password should be at least 8 characters").required("Password is required"),
    subjectIds: Yup.array().of(Yup.string().required("Invalid Subject selected")).min(1, "At least one Subject must be selected").required("Subject are required"),
    userIds: Yup.array().of(Yup.string().required("Invalid Student selected")),
    contact: Yup.object({
      mobile: Yup.string()
        .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
        .required("Mobile number is required"),
      countryCode: Yup.string().required("Countrycode is required"),
    }),
    referralCode: Yup.string().required("Referral Code is required"),
    image: Yup.mixed().required("Class Logo is required"),
    positiveMarks: Yup.string().required("Positive Marks is required"),
    negativeMarks: Yup.string(),
    examTypeId: Yup.string().required("Exam Type is required")

  });

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const response = await dispatch(fileUpload(formData));
      if (response) {
        setFieldValue("image", response?.payload);
      }
    } catch (error) {
      alert("Error uploading file. Please try again.");
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setPreview(imageURL);
      setFieldValue("image", imageURL);
      handleFileUpload(file);
    }
  };
  const handlePDFUpload = async (file, pdfType) => {
    if (file.size > 1000000) {
      alert("File too large. Maximum allowed size is 1MB.");
      return;
    }
    const formData = new FormData();
    formData.append("pdf", file);
    formData.append("pdfType", pdfType);

    try {
      const response = await dispatch(fileUpload(formData));
      console.log("res pdf : ", response)
      if (response) {

        if (pdfType === "terms-condition") {
          setFieldValue("termsAndConditions", response?.payload);
        } else if (pdfType === "privacy-policy") {
          setFieldValue("privacyPolicy", response?.payload);
        }
      }
    } catch (error) {
      alert(`Error uploading ${pdfType}. Please try again.`);
    }
  };
  const handleFileChange = (e, pdfType) => {
    const file = e.target.files[0];
    if (file) {
      if (pdfType === "terms-condition") {
        const fileURL = URL.createObjectURL(file);
        setTermsPreview(fileURL);
      } else if (pdfType === "privacy-policy") {
        const fileURL = URL.createObjectURL(file);
        setPrivacyPreview(fileURL);
      }
      handlePDFUpload(file, pdfType);
    }
  };
  const onSubmit = async (values) => {

    setLoading(true);
    const payload = { ...values };
    if (classesId) {
      payload.classesId = classesId;
    }
    try {
      let response;
      if (classesId) {
        response = await dispatch(editClasses(payload));
      } else {
        response = await dispatch(addClasses(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        navigate("/classes");
        resetForm();
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setValues, resetForm } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const getSingleRecord = useCallback(async () => {
    try {
      await dispatch(getSingleClasses(classesId));
    } catch (error) { }
  }, [dispatch, classesId]);

  useEffect(() => {
    if (classesId) {
      getSingleRecord();
    }
  }, [classesId, getSingleRecord]);
  useEffect(() => {
    dispatch(getAllSubject({ page: 1, limit: 1000 }));
    dispatch(getAllUsers());
    dispatch(getAllExamType());
  }, [dispatch]);

  useEffect(() => {
    if (getsingleClassesData) {
      setValues({
        name: getsingleClassesData.name,
        ownerName: getsingleClassesData.ownerName,
        email: getsingleClassesData.email,
        contact: {
          countryCode: getsingleClassesData.contact.countryCode,
          mobile: getsingleClassesData.contact.mobile,
        },
        password: getsingleClassesData.password,
        isForAllUsers: getsingleClassesData.isForAllUsers,
        referralCode: getsingleClassesData.referralCode,
        image: getsingleClassesData.image,
        termsAndConditions: getsingleClassesData.termsAndConditions,
        subjectIds: getsingleClassesData.subjectIds || [],
        userIds: getsingleClassesData.userIds || [],
        privacyPolicy: getsingleClassesData.privacyPolicy,
        positiveMarks: getsingleClassesData.positiveMarks,
        negativeMarks: getsingleClassesData.negativeMarks,
        examTypeId: getsingleClassesData.examTypeId
      });
      setPreview(getsingleClassesData.image);
      if (getsingleClassesData.termsAndConditions) {
        setTermsPreview(getsingleClassesData.termsAndConditions);
      }

      if (getsingleClassesData.privacyPolicy) {
        setPrivacyPreview(getsingleClassesData.privacyPolicy);
      }
    }
  }, [getsingleClassesData, setValues]);
  useEffect(() => {
    if (action === "Add") {
      resetForm();
      setPreview();
      setTermsPreview();
      setPrivacyPreview();
    }
  }, [action, resetForm]);

  const subjectOptions =
    getSubjectData?.subject_data?.map((subject) => ({
      value: subject._id,
      label: subject.name,
    })) || [];
  const studentOptions =
    getStudentData?.map((student) => ({
      value: student._id,
      label: student.firstName + " " + student.lastName,
      isBlocked: student.isBlocked,
    })) || [];
  const handleSelectAll = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      if (values.userIds?.length === studentOptions?.length) {
        setFieldValue("userIds", []);
      } else {
        const allOptionValues = studentOptions.map((option) => option.value);

        setFieldValue("userIds", allOptionValues);
      }
    }
    //  else if (
    //   selectedOptions.some((option) => option.value === "activeUser")
    // ) {
    //   const activeUser = studentOptions
    //     .filter((student) => student.isBlocked === true)
    //     .map((student) => student.value);
    //   setFieldValue("userIds", activeUser);
    // } else if (
    //   selectedOptions.some((option) => option.value === "InActiveUser")
    // ) {
    //   const inActiveUser = studentOptions
    //     .filter((student) => student.isBlocked === false)
    //     .map((student) => student.value);
    //   setFieldValue("userIds", inActiveUser);
    // }
    else {
      const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
      setFieldValue("userIds", selectedValues);
    }
  };
  const extendedOptions = [
    { value: "all", label: "Select All" },
    // { value: "activeUser", label: "Active Students" },
    // { value: "InActiveUser", label: "InActive Students" },
    ...studentOptions,
  ];
  const examTypeOptions = getExamTypeData?.map((exam) => ({
    value: exam._id,
    label: exam.name,
  }));
  return (
    <div>
      <div className="bg-background py-4 sm:py-4">
        <div className="py-3 w-full sm:mx-auto">
          <div className="px-4 md:py-10 py-5 bg-card shadow rounded-3xl sm:p-10">
            <p className="md:text-3xl text-xl text-center font-medium uppercase text-primary">{action} Classes</p>
            <form className="mt-6" onSubmit={handleSubmit}>
              <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
                <div>
                  <label className="text-sm font-medium text-foreground">Owner Name</label>
                  <input type="text" name="ownerName" className="w-full px-4 py-2 border border-border rounded-xl" value={values.ownerName} onChange={handleChange} onBlur={handleBlur} placeholder="Owner Name" />
                  {touched.ownerName && errors.ownerName && <div className="text-red-500 text-sm">{errors.ownerName}</div>}
                </div>
                <div>
                  <label className="text-sm font-medium text-foreground">Class Name</label>
                  <input type="text" name="name" className="w-full px-4 py-2 border border-border rounded-xl" value={values.name} onChange={handleChange} onBlur={handleBlur} placeholder="Class Name" />
                  {touched.name && errors.name && <div className="text-red-500 text-sm">{errors.name}</div>}
                </div>

                <div>
                  <label className="text-sm font-medium text-foreground">Email</label>
                  <input type="email" name="email" className="w-full px-4 py-2 border border-border rounded-xl" value={values.email} onChange={handleChange} onBlur={handleBlur} />
                  {touched.email && errors.email && <div className="text-red-500 text-sm">{errors.email}</div>}
                </div>

                <div>
                  <label className="text-sm font-medium text-foreground">Password</label>
                  <div className="relative w-full ">
                    <input type={show ? "text" : "password"} name="password" className="w-full px-4 py-2 border border-border rounded-xl" value={values.password} onChange={handleChange} onBlur={handleBlur} disabled={classesId} />
                    {!classesId && (
                      <button type="button" onClick={() => setShow(!show)} className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-primary rounded-e-xl focus:outline-none">
                        <svg className="w-5 h-5" viewBox="0 0 16 16">
                          {show ? <VscEyeClosed title="Show Password" /> : <RxEyeOpen title="Hide Password" />}
                        </svg>
                      </button>
                    )}
                  </div>

                  {touched.password && errors.password && <div className="text-red-500 text-sm">{errors.password}</div>}
                </div>
                <div>
                  <label className="text-sm font-medium text-foreground">Subject</label>
                  <Select
                    isMulti
                    name="subjectIds"
                    options={subjectOptions}
                    className="basic-multi-select mt-1"
                    classNamePrefix="select"
                    value={subjectOptions.filter((option) => values.subjectIds.includes(option.value))}
                    onChange={(selectedOptions) => {
                      setFieldValue("subjectIds", selectedOptions ? selectedOptions.map((option) => option.value) : []);
                    }}
                    onBlur={handleBlur}
                    maxMenuHeight={200}
                  />
                  {touched.subjectIds && errors.subjectIds && <div className="text-red-500 text-sm">{errors.subjectIds}</div>}
                </div>
                <div>
                  <label className="text-sm font-medium text-foreground">Student</label>
                  <Select isMulti name="userIds" options={extendedOptions} className="basic-multi-select mt-1" classNamePrefix="select" value={extendedOptions.filter((option) => values.userIds?.includes(option.value))} onChange={handleSelectAll} onBlur={handleBlur} maxMenuHeight={200} />
                  {touched.userIds && errors.userIds && <div className="text-red-500 text-sm">{errors.userIds}</div>}
                </div>
                <div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Referral Code</label>
                    <input type="text" name="referralCode" className="w-full px-4 py-2 border border-border rounded-xl" value={values.referralCode} onChange={handleChange} onBlur={handleBlur} placeholder="Referral Code" />
                    {touched.referralCode && errors.referralCode && <div className="text-red-500 text-sm">{errors.referralCode}</div>}
                  </div>
                  <div>
                    <label className="inline-flex items-center mt-2">
                      <input type="checkbox" name="isForAllUsers" className="rounded" checked={values.isForAllUsers} onChange={handleChange} />
                      {touched.isForAllUsers && errors.isForAllUsers && <div className="text-red-500 text-sm">{errors.isForAllUsers}</div>}
                      <span className="ml-2">Referral Code Is For All Users</span>
                    </label>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-foreground">Contact</label>
                  <div className="flex space-x-2">
                    <div>
                      <input type="text" name="contact.countryCode" className="w-full px-4 py-2 border border-border rounded-xl" value={values.contact.countryCode} onChange={handleChange} onBlur={handleBlur} placeholder="Country Code" />

                      {touched.contact?.countryCode && errors.contact?.countryCode && <div className="text-red-500 text-sm">{errors.contact?.countryCode}</div>}
                    </div>
                    <div className="w-full">
                      <input type="text" name="contact.mobile" className="w-full px-4 py-2 border border-border rounded-xl" value={values.contact.mobile} onChange={handleChange} onBlur={handleBlur} placeholder="Mobile Number" />
                      {touched.contact?.mobile && errors.contact?.mobile && <div className="text-red-500 text-sm">{errors.contact?.mobile}</div>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid lg:grid-cols-3 mt-4 md:grid-cols-2 grid-cols-1 gap-5">
                <div>

                  <label className="text-sm font-medium text-foreground">Exam Type</label>
                  <Select name="examTypeId" className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]" value={examTypeOptions?.find((option) => option.value === values.examTypeId)} onChange={(e) => setFieldValue("examTypeId", e ? e.value : "")} options={examTypeOptions} classNamePrefix="custom-select" />
                  {touched.examTypeId && errors.examTypeId && <div className="text-red-500 text-sm">{errors.examTypeId}</div>}
                </div>
                <div>
                  <label className="text-sm font-medium text-foreground">Positive Marks</label>
                  <input type="number" name="positiveMarks" className="w-full px-4 py-2 border border-border rounded-xl" value={values.positiveMarks} onChange={handleChange} onBlur={handleBlur} />
                  {touched.positiveMarks && errors.positiveMarks && <div className="text-red-500 text-sm">{errors.positiveMarks}</div>}
                </div>
                <div>
                  <label className="text-sm font-medium text-foreground">Negative Marks</label>
                  <input type="number" name="negativeMarks" className="w-full px-4 py-2 border border-border rounded-xl" value={values.negativeMarks} onChange={handleChange} onBlur={handleBlur} />
                  {touched.negativeMarks && errors.negativeMarks && <div className="text-red-500 text-sm">{errors.negativeMarks}</div>}

                </div>
              </div>
              <div className="grid lg:grid-cols-3 mt-4 md:grid-cols-2 grid-cols-1 gap-5">
                <div>
                  <label className="text-sm font-medium text-foreground">Class Logo</label>
                  <input type="file" name="image" onChange={handleImageChange} className="w-full px-4 py-2 border border-border rounded-xl" />
                  {touched.image && errors.image && <div className="text-red-500 text-sm">{errors.image}</div>}
                  {preview && (
                    <div className="mt-4 flex">
                      <p className="text-md text-foreground me-3">Preview:</p>
                      <img src={preview} alt="Class Logo Preview" className="w-20 h-20 object-cover border border-border rounded-xl" />
                    </div>
                  )}
                </div>

                <div>
                  <label className="text-sm font-medium text-foreground">Terms & Conditions</label>
                  <input type="file" name="termsAndConditions" accept=".pdf" onChange={(e) => handleFileChange(e, "terms-condition")} className="w-full px-4 py-2 border border-border rounded-xl" />

                  {termsPreview && (
                    <div className="mt-4 flex items-center">
                      <p className="text-md text-foreground me-3">Preview:</p>
                      <Link to={termsPreview} target="_blank" rel="noopener noreferrer" className="flex items-center text-primary">
                        <AiFillFilePdf size={40} className="mr-2" />
                        View PDF
                      </Link>
                    </div>
                  )}
                </div>

                <div>
                  <label className="text-sm font-medium text-foreground">Privacy Policy</label>
                  <input type="file" name="privacyPolicy" accept=".pdf" onChange={(e) => handleFileChange(e, "privacy-policy")} className="w-full px-4 py-2 border border-border rounded-xl" />

                  {privacyPreview && (
                    <div className="mt-4 flex items-center">
                      <p className="text-md text-foreground me-3">Preview:</p>
                      <Link to={privacyPreview} target="_blank" rel="noopener noreferrer" className="flex items-center text-primary">
                        <AiFillFilePdf size={40} className="mr-2" />
                        View PDF
                      </Link>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex justify-center">
                <button type="submit" className="w-full sm:w-[250px] min-h-[50px] flex justify-center items-center text-white bg-primary text-lg font-semibold rounded-xl hover:bg-accent mt-7">
                  {loading ? <div className="loader"></div> : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassesDataForm;
